export const loadHighContrastEmulationStylesheet = () =>
  import(/* webpackChunkName: "3-render-highContrastEmulation" */ '../../../util/styles/highContrastEmulation.css');
